import update from 'immutability-helper'
import {
  INITIAL_CREATE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_GET_RESULTS_REDUCER,
  INITIAL_UPDATE_REDUCER
} from '../../constants/reducer'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_SELF_ACCOUNTS,
  GET_SELF_ACCOUNTS_SUCCESS,
  GET_SELF_ACCOUNTS_FAILURE,
  CLEAR_SELF_ACCOUNTS,
  GET_SELF_ACCOUNT,
  GET_SELF_ACCOUNT_SUCCESS,
  GET_SELF_ACCOUNT_FAILURE,
  CLEAR_SELF_ACCOUNT,
  CREATE_SELF_ACCOUNT,
  CREATE_SELF_ACCOUNT_SUCCESS,
  CREATE_SELF_ACCOUNT_FAILURE,
  UPDATE_SELF_ACCOUNT,
  UPDATE_SELF_ACCOUNT_SUCCESS,
  UPDATE_SELF_ACCOUNT_FAILURE,
  CLEAR_UPDATE_SELF_ACCOUNT,
  CLEAR_CREATE_SELF_ACCOUNT,
  GET_PARTNER_SELF_ACCOUNT,
  GET_PARTNER_SELF_ACCOUNT_SUCCESS,
  GET_PARTNER_SELF_ACCOUNT_FAILURE,
  CLEAR_PARTNER_SELF_ACCOUNT
} from '../actions/selfAccounts'
import { updateItem } from '../../helpers/reducerHelpers'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  selfAccounts: INITIAL_GET_RESULTS_REDUCER,
  partnerSelfAccount: INITIAL_GET_REDUCER,
  selfAccount: INITIAL_GET_REDUCER,
  createSelfAccount: INITIAL_CREATE_REDUCER,
  updateSelfAccount: INITIAL_UPDATE_REDUCER
}

export default function selfAccounts(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // get self accounts
    case GET_SELF_ACCOUNTS:
      return update(state, {
        selfAccounts: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_SELF_ACCOUNTS_SUCCESS:
      return update(state, {
        selfAccounts: {
          $merge: {
            isLoading: false,
            results: action.selfAccountsData.results,
            wasLoaded: true
          }
        }
      })
    case GET_SELF_ACCOUNTS_FAILURE:
      return update(state, {
        selfAccounts: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_SELF_ACCOUNTS:
      return update(state, {
        selfAccounts: { $set: initialState.selfAccounts }
      })

    // get self account
    case GET_SELF_ACCOUNT:
      return update(state, {
        selfAccount: { $merge: { isLoading: true } }
      })
    case GET_SELF_ACCOUNT_SUCCESS:
      return update(state, {
        selfAccount: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_SELF_ACCOUNT_FAILURE:
      return update(state, {
        selfAccount: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_SELF_ACCOUNT:
      return update(state, {
        selfAccount: { $set: initialState.selfAccount }
      })

    // get partner self account
    case GET_PARTNER_SELF_ACCOUNT:
      return update(state, {
        partnerSelfAccount: { $merge: { isLoading: true } }
      })
    case GET_PARTNER_SELF_ACCOUNT_SUCCESS:
      return update(state, {
        partnerSelfAccount: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_PARTNER_SELF_ACCOUNT_FAILURE:
      return update(state, {
        partnerSelfAccount: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_PARTNER_SELF_ACCOUNT:
      return update(state, {
        partnerSelfAccount: { $set: initialState.partnerSelfAccount }
      })

    // create self account
    case CREATE_SELF_ACCOUNT:
      return update(state, {
        createSelfAccount: {
          $merge: {
            isLoading: true
          }
        }
      })
    case CREATE_SELF_ACCOUNT_SUCCESS:
      return update(state, {
        selfAccounts: {
          results: { $push: [action.selfAccountData] }
        },
        createSelfAccount: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        }
      })
    case CREATE_SELF_ACCOUNT_FAILURE:
      return update(state, {
        createSelfAccount: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_SELF_ACCOUNT:
      return update(state, {
        createSelfAccount: {
          $set: initialState.createSelfAccount
        }
      })

    // update self account
    case UPDATE_SELF_ACCOUNT:
      return update(state, {
        updateSelfAccount: {
          $merge: {
            data: action.selfAccountData,
            isLoading: true,
            id: action.id
          }
        }
      })
    case UPDATE_SELF_ACCOUNT_SUCCESS:
      return update(state, {
        selfAccounts: {
          results: {
            $apply: items => updateItem(items, action.selfAccountData)
          }
        },
        selfAccount: {
          $merge: {
            data: action.selfAccountData
          }
        },
        updateSelfAccount: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        }
      })
    case UPDATE_SELF_ACCOUNT_FAILURE:
      return update(state, {
        updateSelfAccount: {
          $merge: {
            ...initialState.updateSelfAccount,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_SELF_ACCOUNT:
      return update(state, {
        updateSelfAccount: {
          $set: initialState.updateSelfAccount
        }
      })

    default:
      return state
  }
}
